import React from "react";
import { books } from "../data/books";
import Portfolio from "../components/bookComponents/Portfolio";

const Books = () => {
    return ( <Portfolio books={books}/> )
};

export default Books;
